/* eslint-disable react-hooks/rules-of-hooks */
import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { useFieldValue } from "formik";
import { useTranslation } from "react-i18next";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { isEmptyValue } from "../utils/is-empty-value";
import { GeneralFieldController } from "./general-field-controller";
import { AdverseEventGrades } from "../models/generated/graphql";

export class AdverseEventTraeFieldController extends GeneralFieldController {
	override mapInitialValue(value: unknown): unknown {
		return !this.parent.context.flexEntity ? true : value;
	}

	override useControlProps(): FlexControlProps {
		const [responseReceived] = useFieldValue(AttributeIdentifiers.ResponseReceived);
		const { t } = useTranslation();

		return {
			controlType: "combo",
			options: [
				{ label: t("yes"), value: true },
				{ label: t("no"), value: false },
				{ label: t("NO_INFO"), value: AdverseEventGrades.NoInfo },
			],
			disabled: !isEmptyValue(responseReceived) && !responseReceived,
		};
	}
}
